<script>
    import moment from "moment";

    import { fade } from "svelte/transition";
    import { clickOutside } from "../utils/clickOutside.js";

    export let style;
    export let permission;

    export let value = null; // 2020-10-30
    export let dateLocalFormat = null; // 30.10.2020
    export let placeholder;

    export let save = null;

    let isSelected = false;

    let months = [
        "Јануари",
        "Февруари",
        "Март",
        "Април",
        "Мај",
        "Јуни",
        "Јули",
        "Август",
        "Септември",
        "Октомври",
        "Ноември",
        "Декември",
    ];

    let weekdays = ["П", "В", "С", "Ч", "П", "С", "Н"];

    // format ISO date into localized format
    $: {
        if (value) {
            dateLocalFormat = formatDateFromISOToLocalFormat(value);
        } else {
            dateLocalFormat = null; // resets input to empty
        }
    }

    $: isEmpty = dateLocalFormat == "" || dateLocalFormat == null;

    $: isValidDate =
        isNaN(dateLocalFormat) &&
        moment(dateLocalFormat, "DD.MM.YYYY", true).isValid(); // true is for EXACT MATCH. Фирма 1 results in true without it.

    function onBlurHandler() {
        if (isDropdownVisible) return;

        if (!dateLocalFormat || dateLocalFormat == "") {
            value = null;
        } else if (isValidDate) {
            value = formatDateFromLocalToISOFormat(dateLocalFormat);

            // let parts = dateLocalFormat.split(".");

            // // selectedDate = today;
            // selectedDay = parseInt(parts[0]);
            // selectedMonth = parseInt(parts[1]);
            // selectedYear = parseInt(parts[2]);

            // // what the dropdown is currently showing
            // currentlyShowingDay = parseInt(parts[0]);
            // currentlyShowingMonth = parseInt(parts[1]);
            // currentlyShowingYear = parseInt(parts[2]);
        }

        save(value);
    }

    // 31.12.2021 > 2021-12-31
    function formatDateFromLocalToISOFormat(dateLocal) {
        let parts = dateLocal.split(".");
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }

    // 2021-12-31 > 31.12.2021
    function formatDateFromISOToLocalFormat(dateISO) {
        let parts = dateISO.split("-");
        return `${parts[2]}.${parts[1]}.${parts[0]}`;
    }

    // Initialization
    // Get today year and month
    let today = new Date();
    let todayDay = today.getDate();
    let todayMonth = today.getMonth();
    let todayYear = today.getFullYear();

    // what the dropdown is currently showing
    let currentlyShowingDay = "";
    let currentlyShowingMonth = "";
    let currentlyShowingYear = "";

    // Selected values
    let selectedDate = "";
    let selectedDay = "";
    let selectedMonth = "";
    let selectedYear = "";

    // If date is populated, select the relevant day
    if (value) {
        let reformattedDate = new Date(value);

        selectedYear = reformattedDate.getFullYear();
        selectedMonth = reformattedDate.getMonth();
        selectedDay = reformattedDate.getDate();

        currentlyShowingYear = selectedYear;
        currentlyShowingMonth = selectedMonth;
    } else {
        // Selected values
        selectedDate = today;
        selectedDay = todayDay;
        selectedMonth = todayMonth;
        selectedYear = todayYear;

        // what the dropdown is currently showing
        currentlyShowingDay = todayDay;
        currentlyShowingMonth = todayMonth;
        currentlyShowingYear = todayYear;
    }

    let isDropdownVisible = false;

    let firstDate = null;
    let lastDate = null;
    let lastDay = null;
    let offset = null;

    function showDropdown() {
        isDropdownVisible = true;
        currentlyShowingMonth = selectedMonth;
        currentlyShowingYear = selectedYear;
        generateDates();
    }

    function hideDropdown() {
        isDropdownVisible = false;
    }

    function previousYear() {
        currentlyShowingYear -= 1;
        generateDates();
    }

    function nextYear() {
        currentlyShowingYear += 1;
        generateDates();
    }

    function previousMonth() {
        if (currentlyShowingMonth > 0) {
            currentlyShowingMonth -= 1;
        } else {
            currentlyShowingYear -= 1;
            // setYear();
            currentlyShowingMonth = 11;
        }
        generateDates();
    }

    function nextMonth() {
        if (currentlyShowingMonth < 11) {
            currentlyShowingMonth += 1;
        } else {
            currentlyShowingYear += 1;
            // setYear();
            currentlyShowingMonth = 0;
        }
        generateDates();
    }

    let weeks = [];
    let dayCount = 1;

    function generateDates() {
        weeks = [];
        // Get first and last dates based on year and month.
        firstDate = new Date(currentlyShowingYear, currentlyShowingMonth, 1);
        lastDate = new Date(currentlyShowingYear, currentlyShowingMonth + 1, 0);

        // Returns the day of the month (1-31) for the specified date according to local time.
        lastDay = lastDate.getDate();

        // Returns the day of the week (0-6) for the specified date according to local time.
        // let offset = firstDate.getDay(); // 0 is Sunday, 6 is Saturday.

        // Make Monday the first day, by shifting everything back by one.
        offset = firstDate.getDay() === 0 ? 6 : firstDate.getDay() - 1; // 0 is Monday, 6 is Sunday.

        dayCount = 1;
        // Date rows

        for (let i = 0; i < 6; i++) {
            // Date cells
            let week = [];
            if (dayCount <= lastDay) {
                // Prevent extra row with the last day
                for (let j = 0; j < 7; j++) {
                    if (offset == 0) {
                        // Prevent making extra days like January 32nd for the last row.
                        if (dayCount <= lastDay) {
                            week.push(dayCount);
                            dayCount++;
                        }
                    } else {
                        // Make empty cells until matching day reached.
                        week.push(null);
                        offset--;
                    }
                }
                weeks.push(week);
            }
        }
    }

    function selectDate(day) {
        hideDropdown();

        selectedDay = day;
        selectedMonth = currentlyShowingMonth;
        selectedYear = currentlyShowingYear;

        function addLeadingZero(value) {
            return ("0" + value).slice(-2);
        }

        let d = addLeadingZero(day);
        let m = addLeadingZero(currentlyShowingMonth + 1);
        let y = currentlyShowingYear;

        value = `${y}-${m}-${d}`; // 2020-10-30
        dateLocalFormat = `${d}.${m}.${y}`; // 30.10.2020

        save(value);
    }

    function getCellClass(day) {
        let className = "cell date";

        isSelected =
            currentlyShowingYear === selectedYear &&
            currentlyShowingMonth === selectedMonth &&
            selectedDay === day;

        if (isSelected) {
            className += " selected";
        }

        let isToday =
            currentlyShowingYear === todayYear &&
            currentlyShowingMonth === todayMonth &&
            todayDay === day;

        if (isToday) {
            className += " today";
        }

        if (isToday && isSelected) {
            className += " today-selected";
        }

        return className;
    }
</script>

<div class="container" use:clickOutside on:click-outside={hideDropdown}>
    <input
        {style}
        bind:value={dateLocalFormat}
        on:click={showDropdown}
        on:blur={onBlurHandler}
        on:input={() => {
            isDropdownVisible = false;
        }}
        class:invalid={!isValidDate && !isEmpty}
        disabled={permission == "read"}
        {placeholder}
    />

    {#if isDropdownVisible}
        <div
            class="dropdown"
            in:fade={{ duration: 100 }}
            out:fade={{ duration: 100 }}
        >
            <div class="select">
                <i class="fas fa-caret-left" on:click={previousYear} />
                {currentlyShowingYear}
                <i class="fas fa-caret-right" on:click={nextYear} />
            </div>

            <div class="select">
                <i class="fas fa-caret-left" on:click={previousMonth} />
                {months[currentlyShowingMonth]}
                <i class="fas fa-caret-right" on:click={nextMonth} />
            </div>

            <!--  sdfsdfsdf -->
            <div class="headers">
                {#each weekdays as weekday}
                    <div class="header">{weekday}</div>
                {/each}
            </div>

            <div class="weeks">
                {#each weeks as week}
                    <div class="row">
                        {#each week as day}
                            {#if day}
                                <div
                                    class={getCellClass(day)}
                                    on:click={selectDate(day)}
                                >
                                    {day}
                                </div>
                            {:else}
                                <div class="cell" />
                            {/if}
                        {/each}
                    </div>
                {/each}
            </div>
        </div>
    {/if}
</div>

<style>
    .container {
        /* background: yellow; */
        position: relative;
        display: inline-block;
        /* width: 150px; */
    }

    .dropdown {
        padding: 5px;
        position: absolute;
        background: #f8f8f8;
        color: black;

        display: grid;

        grid-template-columns: 7;
        grid-template-rows: 4;
        flex-direction: column;

        border-radius: 3px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
        z-index: 1;
    }

    .select {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .dropdown i {
        font-size: 20px;
        cursor: pointer;
        padding: 5px 10px;
        opacity: 0.5;
    }

    .dropdown i:hover {
        opacity: 1;
    }

    .headers,
    .row {
        display: flex;
    }

    .header,
    .cell {
        display: flex;
        width: 30px;
        height: 30px;

        align-items: center;
        justify-content: center;
        margin: 2px;
        padding: 5px;

        border-radius: 3px;
    }

    .date {
        /* background: white; */
        cursor: pointer;
    }

    .date:hover {
        font-weight: bold;
        color: black;
        background: #eee;
    }

    .selected {
        font-weight: bold;
        /* border: 2px solid black; */
        background: #666;
        color: white;
    }

    .today {
        font-weight: bold;
        /* border: 1px solid #888; */
        color: red;
    }

    .today-selected {
        font-weight: bold;
        /* border: 1px solid #888; */
        background: red;
        color: white;
    }

    .invalid {
        border: 3px solid red;
    }
</style>
